
/*
 *   File : bank.js
 *   Author URI : https://evoqins.com
 *   Description : Screen to add bank details.
 *   Integrations : null
 *   Version : v1.1
 */
import { useEffect, useState } from "react";
import { LinkText, GradientButton } from "../../../../Component/CTA";
import { CustomTextInput, CustomSelectBox, CustomFilePicker, FilePreview } from "../../../../Component/Form-elements";
import { toast } from "react-toastify";
import APIService from "../../../../Service/api-service";
import { _uploadDocumentToS3 } from "../../../../Service/aws-service";
import { _convertToLabelValueArray, _isFileTypeAllowed } from "../../../../Helper";
import { useSelector } from "react-redux";
import Store from "../../../../Store";

const NRIBankDetail = (props) => {
    const BANK_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA.bank_details);
    console.log('BANK_DATA', BANK_DATA);

    const GENERAL_DATA = useSelector(state => state.generalData.KYC_GENERAL_DATA);

    const [accountHolderName, setAccountHolderName] = useState(BANK_DATA.account_holder_name !== null ? BANK_DATA.account_holder_name : "");
    const [accountHolderNameError, setAccountHolderNameError] = useState("");
    const [acNumber, setAcNumber] = useState(BANK_DATA.account_number !== null ? BANK_DATA.account_number : "");
    const [confirmAcNumber, setConfirmAcNumber] = useState(BANK_DATA.account_number !== null ? BANK_DATA.account_number : "");
    const [acTypes, setAcTypes] = useState(_convertToLabelValueArray(GENERAL_DATA?.nri_account_type) ?? []);
    const [acType, setAcType] = useState(acTypes[0] ?? null);
    console.log('acType', acType);

    const [acTypeErr, setAcTypeErr] = useState("");
    const [ifsc, setIfsc] = useState(BANK_DATA.ifsc_code !== null ? BANK_DATA.ifsc_code : "");
    const [acNumberError, setAcNumberError] = useState('');
    const [confirmAcNumberError, setConfirmAcNumberError] = useState('');
    const [ifscError, setIfscError] = useState('');
    const [bankStatement, setBankStatement] = useState(null);
    const [bankStatementUrl, setBankStatementUrl] = useState(BANK_DATA.bank_statement_url);

    const [cancelledCheque, setCancelledCheque] = useState(BANK_DATA.bank_cheque_url);
    const [cancelledChequeUrl, setCancelledChequeUrl] = useState(null);
    const [cancelledChequeError, setCancelledChequeError] = useState(null);
    const [apiLoader, setApiLoader] = useState(false);

    const [fileLoader, setFileLoader] = useState(false);

    useEffect(() => {
        if (BANK_DATA.bank_statement_url !== null) {
            const decodedURL = decodeURIComponent(decodeURIComponent(BANK_DATA.bank_statement_url));
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setBankStatement(fileName);
        }
        if (BANK_DATA.bank_cheque_url) {
            const decodedURL1 = decodeURIComponent(decodeURIComponent(BANK_DATA.bank_cheque_url));
            const fileName1 = decodedURL1.split('?')[0].split("/").pop();
            setCancelledCheque(fileName1);
        }

        if (BANK_DATA.account_type_id) {
            setAcType({
                value: BANK_DATA.account_type_id,
                label: BANK_DATA.account_type_text
            })
        }

    }, [BANK_DATA]);

    useEffect(() => {
        if (!acNumber || !confirmAcNumber) {
            setConfirmAcNumberError('');
            return;
        }

        if (acNumber === confirmAcNumber) {
            setConfirmAcNumberError('');
        }
    }, [acNumber, confirmAcNumber]);


    // Add this scroll function
    function _scrollToError(element_id) {
        const element = document.getElementById(element_id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            // Optional: Add focus to the input
            element.focus();
        }
    };


    // Form validation
    function _submitBankDetail() {
        let valid_form = true;
        let first_error_id = null;
        let ifsc_regex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

        const formatted_ifsc = ifsc.trim().toUpperCase();
        if (accountHolderName.trim().length === 0 || accountHolderName === null) {
            setAccountHolderNameError('Please provide account holder name');
            valid_form = false;
            if (!first_error_id) first_error_id = "account-holder-name";
        }

        if (acNumber.length === 0) {
            setAcNumberError('Please provide account number');
            valid_form = false;
            if (!first_error_id) first_error_id = "account-number";
        } else if (acNumber.length < 6 || acNumber.length > 18) {
            setAcNumberError('Invalid Account number ');
            valid_form = false;
            if (!first_error_id) first_error_id = "account-number";
        }

        if (confirmAcNumber.length === 0) {
            valid_form = false;
            setConfirmAcNumberError('Please provide account number');
        } else if (confirmAcNumber.length < 6 || confirmAcNumber.length > 18) {
            setConfirmAcNumberError('Invalid Account number ');
            valid_form = false;
            if (!first_error_id) first_error_id = "confirm-account-number";
        } else if (acNumber !== confirmAcNumber) {
            setConfirmAcNumberError('Account number not matching with previous');
            valid_form = false;
            if (!first_error_id) first_error_id = "confirm-account-number";
        }

        if (acType === null) {
            setAcTypeErr('Please select account type');
            valid_form = false;
            if (!first_error_id) first_error_id = "account-type";
        }

        if (formatted_ifsc.length === 0) {
            setIfscError('Please provide IFSC code');
            valid_form = false;
            if (!first_error_id) first_error_id = "ifsc-code";
        }
        else if (!ifsc_regex.test(formatted_ifsc)) {
            setIfscError('Invalid IFSC code');
            valid_form = false;
            if (!first_error_id) first_error_id = "ifsc-code";
        }

        if (bankStatement === null) {
            setCancelledChequeError('Please upload bank statement or cancelled cheque');
            valid_form = false;
            if (!first_error_id) first_error_id = "bank-statement";
        }

        if (valid_form === true) {
            _addBank();
        } else {
            // Scroll to first error
            if (first_error_id) {
                setTimeout(() => _scrollToError(first_error_id), 100);
            }
        }
    };


    function _handleCheque(path, file) {
        // eslint-disable-next-line
        var file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    _fileUpload(file_formatted, file, 1);
                } else {
                    setCancelledChequeError("File size should be less than 5mb");
                }
            }
            else {
                setCancelledChequeError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    };



    //API :: file upload api
    const _fileUpload = (key, file, type) => {
        setCancelledChequeError("");
        setFileLoader(type);
        let url = "general/file-upload";
        let body = {
            "key": `support/${key}`
        }

        APIService(true, url, body).then((response) => {
            if (response.status_code === 200) {
                setFileLoader(type);

                // s3 helper
                _uploadDocumentToS3(response.data, key, file).then((result) => {

                    setFileLoader(false);
                    if (type === 1) {
                        setBankStatement(key);
                        setBankStatementUrl(response.data.view_info); // file got uploaded successfully
                    } else {
                        setCancelledCheque(key);
                        setCancelledChequeUrl(response.data.view_info);
                    }

                }).catch(error => {
                    toast.dismiss();
                    toast.error(error, {
                        type: "error",
                    });
                    setFileLoader(false);
                });

            } else {
                setFileLoader(false);
                toast.dismiss();
                toast.error(response, {
                    type: "error",
                });
            }
        })
    }

    function _addBank() {
        setApiLoader(true);
        let url = 'kyc/add-bank-v2';
        let payload = JSON.stringify({
            "account_holder_name": accountHolderName,
            "account_number": confirmAcNumber,
            "account_type_id": acType?.value,
            "ifsc_code": ifsc,
            "is_default": true,
            "is_manual": true,
            "primary": true,
            "is_review": props.edit,
            "bank_cheque_url": cancelledCheque == null ? null : cancelledChequeUrl,
            "bank_statement_url": bankStatement === null ? null : bankStatementUrl
        });
        APIService(true, url, payload).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                Store.dispatch({
                    type: 'KYC_PROGRESS',
                    payload: response.kyc_data
                });
                if (response.bank_verification_needed === true) {
                    toast.error(response.data, {
                        type: 'error'
                    });
                } else {
                    toast.success(response.data || "Bank details added successfully");
                    props.updateProgress(response.kyc_data.is_review ? 10 : 8, "NRI", props.is_manual);
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: 'error'
                })
            }
            setApiLoader(false);
        })
    }
    return (
        <>
            <div className="row">
                <div className="col-md-8">
                    <h4 className="color-jett-black e-inter-bold e-font-24 mb-2">Add NRI bank account</h4>
                    <p className="color-outer-space e-poppins-regular e-font-16 mb-3">As per regulatory requirements you can invest through a registered bank account only.</p>


                    <div id="account-holder-name" className="col-lg-6 col-12 mt-4 pt-3">
                        <CustomTextInput value={accountHolderName}
                            label="Account Holder Name"
                            postfix="*"
                            error={accountHolderNameError}
                            maxLength={12}
                            onEnter={_submitBankDetail}
                            // inputClass="text-uppercase"
                            handleChange={(e) => {
                                setAccountHolderName(e);
                                setAccountHolderNameError('');
                            }} />
                    </div>

                    <div id="account-number" className="col-lg-6 col-12 mt-4 pt-3">
                        <CustomTextInput
                            value={acNumber}
                            label="Bank account number"
                            postfix="*"
                            type="text"
                            error={acNumberError}
                            onEnter={_submitBankDetail}
                            handleChange={(e) => {
                                if (/^\d*$/.test(e) && e.length <= 16) {
                                    setAcNumber(e.trim());
                                }
                                setAcNumberError('');
                            }}
                        />

                    </div>

                    <div id="confirm-account-number" className="col-lg-6 col-12 mt-4 pt-3">
                        <CustomTextInput
                            value={confirmAcNumber}
                            label="Re-enter current account number"
                            postfix="*"
                            onEnter={_submitBankDetail}
                            type="text"
                            error={confirmAcNumberError}
                            handleChange={(e) => {
                                if (/^\d*$/.test(e) && e.length <= 16) {
                                    setConfirmAcNumber(e.trim());
                                }
                                setConfirmAcNumberError('');
                            }}
                        />
                    </div>


                    <div id="ifsc-code" className="col-lg-6 col-12 mt-4 pt-3">
                        <CustomTextInput value={ifsc}
                            label="IFSC Code"
                            postfix="*"
                            onEnter={_submitBankDetail}
                            error={ifscError}
                            maxLength={12}
                            inputClass="text-uppercase"
                            handleChange={(e) => {
                                setIfsc(e);
                                setIfscError('');
                            }} />
                    </div>
                    <div id="account-type" className="col-lg-6 col-12 mt-4 pt-3">
                        <CustomSelectBox value={acType}
                            label="Account type"
                            postfix="*"
                            options={acTypes}
                            error={acTypeErr}
                            onSelectChange={(e) => { setAcType(e); setAcTypeErr(""); }} />
                    </div>

                    <h5 className="color-jett-black e-poppins-medium e-font-18 mb-2 mt-4">Bank proofs</h5>
                    <p className="color-outer-space e-poppins-regular e-font-16 mb-2">
                        Please provide any of the following documents as bank proof for your account:
                    </p>
                    <span className="color-jett-black e-font-12 e-poppins-medium">NRI Bank Statement</span>
                    <div className="row pt-3">
                        <div className="col-lg-6  mt-lg-0 mt-4">
                            <p className="color-black e-font-14 e-poppins-medium mb-2">Upload bank statement</p>
                            {
                                bankStatement === null ?
                                    (
                                        <div id='bank-statement'>
                                            <CustomFilePicker accept=".png, .pdf, .jpeg "
                                                className="e-select-file"
                                                error={cancelledChequeError}
                                                loading={fileLoader === 1 ? true : false}
                                                onSelectFile={_handleCheque} />
                                        </div>
                                    ) : (
                                        <FilePreview fileName={bankStatement}
                                            removeFile={() => setBankStatement(null)} />
                                    )
                            }
                        </div>
                    </div>
                    <div className="margin-32px-top">
                        {/* validation */}
                        <GradientButton label="Add bank and continue"
                            className="padding-12px-tb px-3 e-font-16"
                            loading={apiLoader}
                            handleClick={_submitBankDetail} />
                    </div>
                </div>
            </div>
        </>

    )

}

export default NRIBankDetail;